import { useGetProjectQuery, useGetUserSettingsQuery } from "gql/generated/types";
import { useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { validate } from "uuid";
import { useUserState } from "store/user-store";
import { apolloErrorToaster } from "../utils/utils";

export default function useProjectContext() {
  const { projectId } = useParams();
  if (!validate(projectId!)) throw new Error(T("error.invalid-project-id"));
  const user = useUserState((s) => s.currentUser);
  const { data: userSettings, loading: userSettingsLoading, error: userSettingsError } = useGetUserSettingsQuery({
    variables: { id: projectId! },
    onError: apolloErrorToaster,
  });
  const { data: project, loading: projectLoading, error: projectError } = useGetProjectQuery({
    variables: { id: projectId! },
    onError: apolloErrorToaster,
  });
  
  return {
    projectId,
    user,
    userSettings,
    project,
    userSettingsLoading,
    projectLoading,
    userSettingsError,
    projectError,
  } as const;
}